<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-25 18:01:41
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-09-25 18:01:59
-->
<template>
    <router-view />
</template>

<script>
export default {
	name: 'Supply',
};
</script>